import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import { Note } from '@lyrahealth-inc/shared-app-logic/src/models/notes/Notes'
import { Transfer } from '@lyrahealth-inc/shared-app-logic/src/models/transfer/Transfer'

import {
  CLIENT_HOME,
  CLIENT_NOTES,
  CLIENTS_SESSIONS,
  DASHBOARD,
  LC_CALENDAR_CURRENT,
  LT_CLIENTS,
} from '../../../common/constants/routingConstants'

export const getOriginRouteDestination = ({
  originRoute,
  isEngageDAProvider,
}: {
  originRoute?: string
  isEngageDAProvider: boolean
}): string => {
  switch (originRoute) {
    case 'riskAlerts':
    case 'tasks':
      return DASHBOARD.route
    case 'clientList':
      return LT_CLIENTS.route
    case 'careTimeline':
      return CLIENTS_SESSIONS.route
    case 'overview':
      return CLIENT_HOME.route
    case 'calendar':
      return isEngageDAProvider ? LC_CALENDAR_CURRENT.route : CLIENT_NOTES.route
    default:
      return CLIENT_NOTES.route
  }
}

export const getPendingChargeNavState = (
  note: Note,
  sessions: Appointment[],
  pendingTransfers?: Transfer[],
): {
  needToUpdateCharge: boolean
  chargeId?: string
} => {
  const appointmentCharge = pendingTransfers?.find((transfer) => transfer.appointment_id === note.appointment_id)
  const appointment = sessions.find((session) => session.appointmentId === note.appointment_id)

  return {
    needToUpdateCharge: appointment != null && appointment.changeReason !== 'clientIneligible',
    chargeId: appointmentCharge?.id,
  }
}
